import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "driver" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M12.0625 2.3125C6.71211 2.3125 2.375 6.64961 2.375 12C2.375 17.3504 6.71211 21.6875 12.0625 21.6875C17.4129 21.6875 21.75 17.3504 21.75 12C21.75 6.64961 17.4129 2.3125 12.0625 2.3125ZM12.0625 4.8125C15.5988 4.8125 18.5398 7.38164 19.134 10.75H15.466C15.0328 10.0059 14.2359 9.5 13.3129 9.5H10.8129C9.88984 9.5 9.09258 10.0059 8.65977 10.75H4.9918C5.58516 7.38164 8.52617 4.8125 12.0625 4.8125ZM4.99102 13.25H8.9375L10.8125 15.75V19.0715C7.85117 18.5488 5.51367 16.2113 4.99102 13.25ZM13.3125 19.0715V15.75L15.1875 13.25H19.134C18.6113 16.2113 16.2738 18.5488 13.3125 19.0715Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }